import AllLeaves from "../leave/view/AllLeaves.vue";
import Approvals from "../leave/view/Approvals.vue";
import LeaveForm from "../leave/view/LeaveForm.vue";
import EditLeave from "../leave/view/EditLeave.vue";
import settings from "../leave/view/settings.vue";
import LeaveTypeSettings from "../leave/view/LeaveTypeSettings.vue";
import LeaveTypeSettingsForm from "../leave/view/LeaveTypeSettingsForm.vue";
import LeaveApprovalSettings from "../leave/view/LeaveApprovalSettings.vue";
import LeaveApprovaSettingsForm from "../leave/view/LeaveApprovalSettingsForm.vue";
import EditLeaveTypeForm from "../leave/view/EditLeaveTypeForm.vue";
import EditLeaveApprovalForm from "../leave/view/EditLeaveApprovalForm.vue";

export default [
  {
    path: "all",
    component: AllLeaves,
  },
  {
    path: "approvals",
    component: Approvals,
  },
  {
    path: "create",
    component: LeaveForm,
  },
  {
    name: "editAdmin-leave",
    path: "edit/:id",
    component: EditLeave,
  },
  {
    path: "settings",
    component: settings,
  },
  {
    path: "settings/leave-type",
    component: LeaveTypeSettings,
  },
  {
    path: "settings/leave-approval",
    component: LeaveApprovalSettings,
  },
  {
    path: "settings/leave-approval/create",
    component: LeaveApprovaSettingsForm,
  },
  {
    path: "settings/leave-type/create",
    component: LeaveTypeSettingsForm,
  },
  {
    name: "edit-leaveType",
    path: "settings/leave-type/edit/:id",
    component: EditLeaveTypeForm,
  },
  {
    name: "edit-leaveApprover",
    path: "settings/leave-approval/edit/:id",
    component: EditLeaveApprovalForm,
  },
];
